export default class LondonUndergroundPositionalSystem {
    static display_formats = {
        lcs_code_meterage: "LCS Code and Metre",
    };

    displayFields(display_format) {
        return LondonUndergroundPositionalSystem.displayFields(display_format);
    }

    static displayFields(display_format) {
        return ["LCS", "METRE", "LINE"];
    }

    static display_fields = {
        LCS: {
            name: "LCS Code",
            rules: [{ required: true }],
        },
        // LINE: {
        //     name: "Line",
        //     rules: [{}],
        // },
        METRE: {
            name: "Metre",
            rules: [{ required: true, type: "integer" }],
        },
    };

    static fields(display_format) {
        return ["LCS", "METRE", "LINE"];
    }

    fields(display_format) {
        return LondonUndergroundPositionalSystem.fields(display_format);
    }

    field_value(field, datum_offsets) {
        switch (field) {
            case "LCS":
                return this.route;
            case "LINE":
                return this.subposition;
            case "METRE":
                return this.metre;
            default:
                return null;
        }
    }

    static from_fields(system_id, display_format, fields, datum_offsets) {
        return new LondonUndergroundPositionalSystem(system_id, fields.LCS, fields.METRE, fields.LINE);
    }

    static from_search(system_id, fields) {
        const position = parseInt(fields.paramTwo);
        return new LondonUndergroundPositionalSystem(system_id, fields.paramOne, position, null);
    }

    constructor(system_id, route, position, subposition, sources) {
        this.system = system_id;
        this.route = route;
        this.position = position;
        if (this.position) {
            this.metre = Math.floor(this.position);
        }
        this.subposition = subposition;
    }

    to_string(display_format, datum_offsets) {
        return `${this.route} ${this.metre} ${this.subposition} `;
    }
}
